export const CommonMessages = {

  NonEmptyField: "Não pode estar vazio",
  InvalidEmail: "Email inválido",
  InvalidCPF: "CPF inválido",
  InvalidPassword: "Senha inválida",
  Error: "Erro",
  Alert: "Alerta",
  InvalidCNPJ: "CNPJ inválido",
  Success: "Sucesso!",

  MinimoTresCaracteres: "O campo Palavra ou frase buscado deve conter pelo menos três caracteres, entre letras e números.",
  MinimoCaracteresTelefone: "Telefone informado inválido, o telefone deve ter pelo menos 10 números.",
  LimiteMinimoCodigoAutenticidade: "O código informado deve conter apenas números, com o mínimo de 18 caracteres",
}